module.exports = __webpack_public_path__ + "static/media/iconShare--link.3b299326.svg";